<dx-splitter #splitter class="w-100 h-100">

    <dxi-item [resizable]="true" [collapsible]="true" minSize="260px" size="260px">
        <div class="p-2 w-100">
            <h4>{{'COMMON.LABEL_TOC' | translate}}</h4>
            <ul class="list-group list-group-flush w-100">
                @for (item of toc; track item) {
                <li class="list-group-item" [style.paddingLeft.px]="(item.level - 1) * 16">
                    <a routerLink="." [fragment]="item.id">{{ item.text }}</a>
                </li>
                }
            </ul>
        </div>
    </dxi-item>

    <dxi-item [resizable]="true">
        <div class="p-2 h-100 w-100">
            <div class="d-flex justify-content-end bg-gradient">

                <dx-button
                    [text]="'COMMON.ACTION_DOWNLOAD_PDF' | translate"
                    [icon]="downloadInProgress ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-file-pdf'"
                    type="default"
                    stylingMode="outlined"
                    [disabled]="downloadInProgress || !markdown"
                    [height]="40"
                    (onClick)="downloadPdf()"></dx-button>
            </div>
            <app-scroll-view style="max-height: calc(100% - 40px);">
                @if(markdown){
                    <markdown [data]="markdown" (ready)="onMarkdownReady()"></markdown>
                }
                @else {
                    <app-load-indicator />
                }
            </app-scroll-view>

            @if(downloadInProgress){
                <app-load-indicator />
            }
        </div>
    </dxi-item>

</dx-splitter>

@if (loadIndicatorVisible) {
    <app-load-indicator />
}
